import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import cx from 'classnames';

const InputToggleCustomItem = (props) => {
  const {
    input,
    meta: { touched, error },
    title,
    className,
    val,
    id,
  } = props;
  const isSelected = val === input.value;
  const classes = cx({
    'toggle-group__item': true,
    [`${className}`]: className,
    'toggle-group__item--selected': isSelected,
    'toggle-group__item--error': touched && error,
  });
  return (
    <label className={classes}>
      <input
        {...input}
        id={id}
        type="radio"
        className="toggle-group__item-input"
        value={val}
        checked={isSelected}
      />
      <FormattedHTMLMessage id={title} />
    </label>
  );
};

InputToggleCustomItem.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  id: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  val: PropTypes.any,
};

const InputToggleGroup = (props) => {
  const { list, name, ...fieldParams } = props;
  return (
    <div className="toggle-group">
      <div className="toggle-group__wrapper">
        {list.map((item) => (
          <Field
            {...fieldParams}
            id={item.id ? item.id : item.type}
            key={item.type}
            title={item.title}
            className={item.className}
            name={name}
            val={item.type}
            component={InputToggleCustomItem}
          />
        ))}
      </div>
    </div>
  );
};

InputToggleGroup.propTypes = {
  name: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
};

export default InputToggleGroup;
